import { useState } from 'react';
import { Alert, Button, CircularProgress, Stack, TextField } from '@mui/material';
import { errorMessage } from '@/api/errorMessage';
import { money } from '@/billing/planCopy';
import { useNotify } from '@/components/feedback/notificationsContext';
import { useMyReferrals, useUseCoupon } from './api';

/**
 * "Tenho um cupom": whoever referred me earns R$ 10 when I first pay, and I
 * get a discount on that first invoice. Shows who referred me once there is
 * someone; shows nothing after my first payment.
 */
export function CouponBox({ onUsed }: { onUsed?: () => void }) {
  const referrals = useMyReferrals();
  const use = useUseCoupon();
  const notify = useNotify();
  const [code, setCode] = useState('');
  const data = referrals.data;
  if (!data) return null;
  if (data.referredBy && data.welcomeDiscountCents > 0) {
    return (
      <Alert severity="success">
        Indicação de {data.referredBy}: {money(data.welcomeDiscountCents)} de desconto na primeira
        fatura.
      </Alert>
    );
  }
  if (!data.canUseCoupon) return null;
  const submit = async () => {
    const result = await use.mutateAsync(code.trim());
    notify(
      result.referredBy ? `Cupom de ${result.referredBy} aplicado.` : 'Cupom aplicado.',
      'success',
    );
    setCode('');
    onUsed?.();
  };
  return (
    <Stack spacing={1}>
      {use.isError && <Alert severity="error">{errorMessage(use.error, 'Cupom inválido.')}</Alert>}
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
        <TextField
          label="Cupom de indicação (opcional)"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          size="small"
          helperText={`Recebeu um cupom? Você ganha ${money(500)} de desconto na primeira fatura.`}
          slotProps={{ htmlInput: { maxLength: 16, autoCapitalize: 'characters' } }}
          sx={{ flexGrow: 1 }}
        />
        <Button
          variant="outlined"
          disabled={code.trim().length < 4 || use.isPending}
          onClick={() => void submit().catch(() => undefined)}
          sx={{ alignSelf: { sm: 'flex-start' }, height: 40 }}
        >
          {use.isPending ? <CircularProgress size={18} color="inherit" /> : 'Usar cupom'}
        </Button>
      </Stack>
    </Stack>
  );
}
